import { FloatingWhatsApp } from '@carlos8a/react-whatsapp-floating-button';
import logo from '../../images/repLogo.png'

export function Zapzap() {
    return (
        <div>
            <FloatingWhatsApp
                phoneNumber='5513988223735'
                accountName='República do Boxe' 
                avatar={logo}
                statusMessage='Disponível agora'
                initialMessageByServer='Olá, vamos treinar juntos'
                initialMessageByClient='Olá, tenho interesse nas aulas de boxe.'
                startChatText='Marque sua aula grátis agora'
                allowEsc={true} 
                allowClickAway={true}
            />
        </div>
    );
}